import {
    HttpHandler,
    HttpInterceptor,
    HttpRequest,
    HttpResponse
} from "@angular/common/http";

import { HttpHeaders } from '@angular/common/http';
import { Injectable } from "@angular/core";
import { LoaderService } from '../services/loader.service';
import { tap } from "rxjs/operators";

@Injectable()
export class LoaderInterceptor implements HttpInterceptor {
    constructor(private _loaderService: LoaderService) { }
    intercept(request: HttpRequest<any>, next: HttpHandler) {


        this._loaderService.ShowLoader();
        return next.handle(request).pipe(
            tap(
                req => {
                    if (req instanceof HttpResponse) {


                        this._loaderService.HideLoader();
                    }
                },
                err => {

                    this._loaderService.HideLoader();
                }
            )
        );


    }
}
// @Injectable()
// class LoggingInterceptor implements HttpInterceptor {

//   intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>>{
//       const started = Date.now()
//     return next.handle(req).pipe(
//         finalize(() => {
//             const elapsed = Date.now() - started;
//             log(`URL: ${req.url} Method: ${req.method} Time took: ${elapsed} ms`)
//         }))
//     }
//   }
// }